import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import SEO from '../../components/feature/SEO';

interface Section {
  id: string;
  title: string;
  content: React.ReactNode;
}

const datenschutzSections: Section[] = [
  {
    id: 'verantwortlicher',
    title: '1. Verantwortlicher',
    content: (
      <div className="text-sm text-gray-600 space-y-2 leading-relaxed">
        <p>Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:</p>
        <div className="bg-gray-50 rounded-lg p-4 border border-gray-100">
          <p className="font-semibold text-gray-900">IGM Facility Service</p>
          <p>Industriestr. 37, 40878 Ratingen</p>
          <p>Telefon: <a href="tel:+492102739807" className="text-[#0D2B4E] hover:underline">02102 7398070</a></p>
          <p>E-Mail: <a href="mailto:kontakt@igmfacilityservice.de" className="text-[#0D2B4E] hover:underline">kontakt@igmfacilityservice.de</a></p>
        </div>
      </div>
    ),
  },
  {
    id: 'allgemein',
    title: '2. Allgemeine Hinweise',
    content: (
      <p className="text-sm text-gray-600 leading-relaxed">
        Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln
        Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften
        sowie dieser Datenschutzerklärung. Wenn Sie diese Website benutzen, werden verschiedene
        personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie persönlich
        identifiziert werden können. Die vorliegende Datenschutzerklärung erläutert, welche Daten wir
        erheben und wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das geschieht.
        Wir weisen darauf hin, dass die Datenübertragung im Internet (z. B. bei der Kommunikation per
        E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch
        Dritte ist nicht möglich.
      </p>
    ),
  },
  {
    id: 'hosting',
    title: '3. Hosting und Bereitstellung der Website',
    content: (
      <div className="text-sm text-gray-600 space-y-3 leading-relaxed">
        <p>
          Diese Website wird bei einem externen Dienstleister gehostet (Hoster). Die personenbezogenen
          Daten, die auf dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert.
          Hierbei kann es sich v. a. um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten,
          Vertragsdaten, Kontaktdaten, Namen, Webseitenzugriffe und sonstige Daten, die über eine Website
          generiert werden, handeln.
        </p>
        <p>
          Der Einsatz des Hosters erfolgt zum Zwecke der Vertragserfüllung gegenüber unseren potenziellen
          und bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse einer sicheren, schnellen
          und effizienten Bereitstellung unseres Online-Angebots durch einen professionellen Anbieter
          (Art. 6 Abs. 1 lit. f DSGVO).
        </p>
      </div>
    ),
  },
  {
    id: 'datenerfassung',
    title: '4. Datenerfassung auf unserer Website',
    content: (
      <div className="text-sm text-gray-600 space-y-4 leading-relaxed">
        <div>
          <p className="font-semibold text-gray-800 mb-1">Server-Log-Dateien</p>
          <p>
            Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten
            Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind: Browsertyp
            und Browserversion, verwendetes Betriebssystem, Referrer URL, Hostname des zugreifenden
            Rechners, Uhrzeit der Serveranfrage, IP-Adresse.
          </p>
          <p className="mt-2">
            Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Die
            Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber
            hat ein berechtigtes Interesse an der technisch fehlerfreien Darstellung und der Optimierung
            seiner Website – hierzu müssen die Server-Log-Files erfasst werden.
          </p>
        </div>
        <div>
          <p className="font-semibold text-gray-800 mb-1">Cookies</p>
          <p>
            Unsere Internetseiten verwenden so genannte „Cookies". Cookies sind kleine Textdateien und
            richten auf Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die
            Dauer einer Sitzung (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät
            gespeichert. Session-Cookies werden nach Ende Ihres Besuchs automatisch gelöscht. Permanente
            Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese selbst löschen oder eine
            automatische Löschung durch Ihren Webbrowser erfolgt.
          </p>
        </div>
      </div>
    ),
  },
  {
    id: 'kontaktformular',
    title: '5. Kontaktformular und Anfragen',
    content: (
      <div className="text-sm text-gray-600 space-y-3 leading-relaxed">
        <p>
          Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem
          Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung
          der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir
          nicht ohne Ihre Einwilligung weiter.
        </p>
        <p>
          Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern
          Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung
          vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung
          auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen
          (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern
          diese abgefragt wurde.
        </p>
        <p>
          Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei uns, bis Sie uns zur Löschung
          auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung
          entfällt (z. B. nach abgeschlossener Bearbeitung Ihrer Anfrage). Zwingende gesetzliche
          Bestimmungen – insbesondere Aufbewahrungsfristen – bleiben unberührt.
        </p>
      </div>
    ),
  },
  {
    id: 'google-maps',
    title: '6. Google Maps',
    content: (
      <div className="text-sm text-gray-600 space-y-3 leading-relaxed">
        <p>
          Diese Seite nutzt den Kartendienst Google Maps. Anbieter ist die Google Ireland Limited,
          Gordon House, Barrow Street, Dublin 4, Irland. Zur Nutzung der Funktionen von Google Maps
          ist es notwendig, Ihre IP-Adresse zu speichern. Diese Informationen werden in der Regel an
          einen Server von Google in den USA übertragen und dort gespeichert.
        </p>
        <p>
          Die Nutzung von Google Maps erfolgt im Interesse einer ansprechenden Darstellung unserer
          Online-Angebote und an einer leichten Auffindbarkeit der von uns auf der Website angegebenen
          Orte. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar.
          Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschließlich
          auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO.
        </p>
        <p>
          Mehr Informationen zum Umgang mit Nutzerdaten finden Sie in der Datenschutzerklärung von
          Google:{' '}
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="text-[#0D2B4E] underline hover:no-underline"
          >
            https://policies.google.com/privacy
          </a>
          .
        </p>
      </div>
    ),
  },
  {
    id: 'rechte',
    title: '7. Ihre Rechte als betroffene Person',
    content: (
      <div className="text-sm text-gray-600 space-y-3 leading-relaxed">
        <p>Sie haben gegenüber uns folgende Rechte hinsichtlich Ihrer personenbezogenen Daten:</p>
        <div className="grid sm:grid-cols-2 gap-3">
          {[
            { icon: 'ri-eye-line', title: 'Auskunftsrecht', desc: 'Art. 15 DSGVO – Recht auf Auskunft über gespeicherte Daten' },
            { icon: 'ri-edit-line', title: 'Berichtigungsrecht', desc: 'Art. 16 DSGVO – Recht auf Berichtigung unrichtiger Daten' },
            { icon: 'ri-delete-bin-line', title: 'Löschungsrecht', desc: 'Art. 17 DSGVO – Recht auf Löschung Ihrer Daten' },
            { icon: 'ri-pause-circle-line', title: 'Einschränkungsrecht', desc: 'Art. 18 DSGVO – Recht auf Einschränkung der Verarbeitung' },
            { icon: 'ri-upload-cloud-line', title: 'Datenübertragbarkeit', desc: 'Art. 20 DSGVO – Recht auf Datenübertragbarkeit' },
            { icon: 'ri-close-circle-line', title: 'Widerspruchsrecht', desc: 'Art. 21 DSGVO – Recht auf Widerspruch gegen die Verarbeitung' },
          ].map((r) => (
            <div key={r.title} className="flex items-start gap-3 p-3 bg-gray-50 rounded-lg border border-gray-100">
              <div className="w-8 h-8 bg-[#0D2B4E]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className={`${r.icon} text-[#0D2B4E] text-sm`} />
              </div>
              <div>
                <p className="font-semibold text-gray-800 text-xs">{r.title}</p>
                <p className="text-gray-500 text-xs mt-0.5">{r.desc}</p>
              </div>
            </div>
          ))}
        </div>
        <p className="mt-2">
          Sie haben außerdem das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung
          Ihrer personenbezogenen Daten durch uns zu beschweren. Zuständige Aufsichtsbehörde in NRW ist
          die Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen (LDI NRW),
          Kavalleriestr. 2–4, 40213 Düsseldorf.
        </p>
      </div>
    ),
  },
  {
    id: 'speicherung',
    title: '8. Speicherdauer',
    content: (
      <p className="text-sm text-gray-600 leading-relaxed">
        Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde,
        verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt.
        Wenn Sie ein berechtigtes Löschersuchen geltend machen oder eine Einwilligung zur
        Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich
        zulässigen Gründe für die Speicherung Ihrer personenbezogenen Daten haben (z. B. steuer- oder
        handelsrechtliche Aufbewahrungsfristen); im letztgenannten Fall erfolgt die Löschung nach
        Fortfall dieser Gründe. Handels- und steuerrechtliche Aufbewahrungsfristen betragen in der
        Regel 6 bis 10 Jahre.
      </p>
    ),
  },
  {
    id: 'aenderungen',
    title: '9. Änderungen dieser Datenschutzerklärung',
    content: (
      <p className="text-sm text-gray-600 leading-relaxed">
        Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen
        rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen in der
        Datenschutzerklärung umzusetzen, z. B. bei der Einführung neuer Services. Für Ihren erneuten
        Besuch gilt dann die neue Datenschutzerklärung. Stand: März 2026.
      </p>
    ),
  },
];

export default function DatenschutzPage() {
  const [activeSection, setActiveSection] = useState<string | null>(null);

  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <SEO
        title="Datenschutzerklärung | IGM Facility Service"
        description="Datenschutzerklärung gemäß DSGVO, BDSG und TMG – IGM Facility Service Ratingen. Informationen zur Verarbeitung Ihrer personenbezogenen Daten."
        robots="noindex, nofollow"
      />
      <Navbar />

      {/* Hero */}
      <section className="pt-28 pb-10 sm:pt-32 bg-[#0D2B4E]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-2 mb-3">
            <Link to="/" className="text-white/50 text-sm hover:text-white/80 transition-colors">Startseite</Link>
            <span className="text-white/30 text-sm">/</span>
            <span className="text-white/80 text-sm">Datenschutzerklärung</span>
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold text-white mb-3">Datenschutzerklärung</h1>
          <p className="text-white/70 text-sm">Gemäß DSGVO, BDSG und TMG — Stand: März 2026</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-14 bg-[#F8F7F4]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-[240px_1fr] gap-8 items-start">

            {/* Table of Contents – sticky sidebar */}
            <nav className="hidden lg:block sticky top-24">
              <div className="bg-white rounded-xl border border-gray-100 p-5">
                <p className="text-xs font-bold text-gray-500 uppercase tracking-widest mb-3">Inhalt</p>
                <ul className="space-y-1">
                  {datenschutzSections.map((s) => (
                    <li key={s.id}>
                      <a
                        href={`#${s.id}`}
                        onClick={() => setActiveSection(s.id)}
                        className={`block px-3 py-2 rounded-lg text-xs font-medium transition-colors cursor-pointer ${
                          activeSection === s.id
                            ? 'bg-[#0D2B4E] text-white'
                            : 'text-gray-600 hover:bg-gray-50 hover:text-[#0D2B4E]'
                        }`}
                      >
                        {s.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </nav>

            {/* Sections */}
            <div className="space-y-4">
              {datenschutzSections.map((section) => (
                <div
                  key={section.id}
                  id={section.id}
                  className="bg-white rounded-xl border border-gray-100 p-6 sm:p-7 scroll-mt-28"
                >
                  <h2 className="text-base font-bold text-gray-900 mb-3 pb-3 border-b border-gray-100">
                    {section.title}
                  </h2>
                  {section.content}
                </div>
              ))}

              {/* Contact for Data Requests */}
              <div className="bg-[#0D2B4E] rounded-xl p-6 sm:p-7 text-white">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-shield-user-line text-xl text-white" />
                  </div>
                  <div>
                    <h3 className="font-bold text-base mb-1">Datenschutzanfragen</h3>
                    <p className="text-white/70 text-sm leading-relaxed mb-4">
                      Für Anfragen zur Auskunft, Löschung oder Berichtigung Ihrer Daten wenden Sie
                      sich direkt an uns:
                    </p>
                    <div className="flex flex-wrap gap-3">
                      <a
                        href="mailto:kontakt@igmfacilityservice.de"
                        className="inline-flex items-center gap-2 bg-white text-[#0D2B4E] px-4 py-2.5 rounded-lg text-sm font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        <i className="ri-mail-line" />
                        kontakt@igmfacilityservice.de
                      </a>
                      <a
                        href="tel:+492102739807"
                        className="inline-flex items-center gap-2 bg-white/10 text-white px-4 py-2.5 rounded-lg text-sm font-semibold hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        <i className="ri-phone-line" />
                        02102 7398070
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              {/* Navigation */}
              <div className="flex flex-col sm:flex-row gap-3">
                <Link
                  to="/"
                  className="inline-flex items-center justify-center gap-2 bg-[#0D2B4E] text-white px-6 py-3 rounded-lg font-semibold text-sm hover:bg-[#0a2240] transition-colors whitespace-nowrap cursor-pointer"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-left-line" />
                  </div>
                  Zurück zur Startseite
                </Link>
                <Link
                  to="/impressum"
                  className="inline-flex items-center justify-center gap-2 border border-gray-200 text-gray-700 px-6 py-3 rounded-lg font-semibold text-sm hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Impressum ansehen
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line" />
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
